import {actions} from '../reducers/topHeader';

export const setTitle = (title: string) => {
    return (dispatch) => {
        dispatch({
            type: actions.SET_TOP_HEADER_TITLE,
            payload: title
        })
    }
};

export const enableSpinner = (message: string, progressInfo?: string) => {
    return (dispatch) => {
        dispatch({
            type: actions.ENABLE_TOP_HEADER_SPINNER,
            payload: {message, progressInfo}
        })
    }
};

export const disableSpinner = (message: string) => {
    return (dispatch) => {
        dispatch({
            type: actions.DISABLE_TOP_HEADER_SPINNER,
            payload: message
        })
    }
};
export const disableAllSpinners = () => {
    return (dispatch) => {
        dispatch({type: actions.DISABLE_ALL_TOP_HEADER_SPINNERS});
    }
};


// WEBPACK FOOTER //
// ./app/actions/topHeaderActions.ts